import 'common/graph-login-app/index';
